import { BasicResponsiveImage, Box, BulletListContent, Typography, Ul } from '@vp/swan';
import { StaticImageData } from '@99designs/design-services-common';

export type OptionDescriptionProps = {
    title: string;
    heroImage: StaticImageData;
    content: string[];
    inclusions: string[];
};

export function OptionDescription({
    title,
    content,
    inclusions,
    heroImage,
}: OptionDescriptionProps) {
    return (
        <Box mb={8}>
            <BasicResponsiveImage aspectRatio={2 / 3} as="picture">
                <img src={heroImage.src} alt="" role="presentation" />
            </BasicResponsiveImage>
            <Typography fontSkin="title-subsection" mb={4} mt={5}>
                {title}
            </Typography>
            {content.map((line) => (
                <Typography mb={4}>{line}</Typography>
            ))}
            <Ul aria-labelledby="inclusions-list" skin="checkmark">
                {inclusions.map((inclusion) => (
                    <li>
                        <BulletListContent>{inclusion}</BulletListContent>
                    </li>
                ))}
            </Ul>
        </Box>
    );
}
